import React, { useEffect, useMemo, useState } from "react";
import Button from "components/Button";
import { Template } from "layouts/Template";
import { MoodEmpty } from "tabler-icons-react";
import { useNavigate, useParams } from "react-router-dom";
import { Data } from "utils/data";
import Finish from "pages/home/components/Finish";
import {
  useAddDiagnostiqueEleveTentativeMutation,
  useGetEpreuvexByDiagnostiqueQuery,
  useSendTranscriptionMutation,
} from "redux_dir/features/diagnostiqueApi";
import useGetUserInfo from "hooks/useGetUserInfo";
import WordPage from "pages/home/components/WordPage";
import { useGetDiagnostiqueWithNiveauxQuery } from "redux_dir/features/parentApi";
import useQuery from "components/useQuery";
import { useDispatch } from "react-redux";
import {
  setEpreuveNote,
  setEscoreNiveau,
} from "redux_dir/features/diagnostiqueSlice";
import { useSelector } from "react-redux";
import { getNumber } from "utils/soted";
import {
  calculerNoteFinaleByPercent,
  calculerNoteTextToSpeachWithTimer,
  compareText,
  compareTextWithPosition,
  correctFigure,
  correctionLettreManquante,
  correctionLettreManquanteLength,
  correctTsq,
} from "utils/comparentText";
import { progressImage } from "utils/images";
import { useGetEleveQuery } from "redux_dir/features/eleveApi";
import Loader from "components/Loader";
import { getCurrentEleve, setTentatives } from "redux_dir/features/eleveSlice";
import { spliterText } from "pages/home/components/TextSpeach";
import { spliterSentences } from "pages/home/components/AudioRecording";
import Analytics from "utils/analytics";
import { toast } from "sonner";
import { setIncreaseCredit, getParentForm, setParentForm } from "redux_dir/features/parentSlice";
import { ENABLE_CREDIT_SYSTEM } from "constants";
import { useUpdateParentMutation } from "redux_dir/features/parentApi";
import {
  trackDiagnosticProgress,
  trackDiagnosticNiveauSuivant,
  trackDiagnosticCompleted,
} from "utils/diagnosticTracking";

async function sendElements(elements, diagnostiqueNiveaux, currentLevel, current, sendTranscription) {
  const target = elements?.map((item) => item?.item).join(",");
  const formData = new FormData();

  // Extract temps_lecture from current exercise data
  let tempsLecture = 5; // Default to 5 seconds
  try {
    const currentExercise = diagnostiqueNiveaux?.data[currentLevel]?.data[current];

    // Try to get temps_lecture from consigne first
    const consigneData = currentExercise?.consigne?.[0];
    if (consigneData) {
      try {
        const parsedConsigne = JSON.parse(consigneData);
        if (parsedConsigne.temps_lecture) {
          tempsLecture = parsedConsigne.temps_lecture;
        }
      } catch (parseError) {
        console.log("Consigne is not JSON, checking correction_dp");
      }
    }

    // If no temps_lecture found in consigne, check if word is in correction_dp
    if (tempsLecture === 5) {
      const correctionDp = currentExercise?.correction_dp?.[0];
      if (correctionDp && !consigneData) {
        // Word is in correction_dp, use default time
        console.log("Mot trouvé dans correction_dp, temps par défaut utilisé:", tempsLecture);
      }
    }
  } catch (error) {
    console.error("Erreur parsing consigne pour temps_lecture:", error);
  }

  for (const element of elements) {
    if (element.file) {
      // Always use .wav extension for the filename
      let filename = element.file.name;
      if (!filename || !filename.endsWith('.wav')) {
        filename = 'audio.wav';
      }
      formData.append("file", element.file, filename);
    }
  }
  formData.append("target", target);

  // Always add temps_lecture to the request (default 5s if not found)
  formData.append("temps_lecture", tempsLecture);
  console.log("Temps de lecture ajouté à la requête:", tempsLecture);

  try {
    // Utiliser la mutation RTK Query au lieu d'axios
    const res = await sendTranscription({ formData }).unwrap();

    // Le POST /transcription/ retourne déjà le score de cet envoi dans
    // llm_score.score (bonne_lecture). Aucun AudioTranscript n'est créé
    // pour ce chemin : le getAll ne liste que des records motParmot, le
    // score_binaire récupéré appartenait donc à un autre exercice.
    const llmScore = res?.llm_score || res?.data?.llm_score;
    return {
      score: llmScore?.score ?? res?.score ?? res?.data?.score ?? 0,
      llm_score: llmScore
    };
  } catch (error) {
    console.error("Erreur lors de l'envoi des éléments:", error);
    return { score: 0, llm_score: null };
  }
}

function ExerciceLecturePage() {
  const params = useParams();
  const navigation = useNavigate();
  const searchParams = useQuery();

  const dispatch = useDispatch();

  const { csrfToken } = useGetUserInfo();

  const [data] = useState(
    Data[params.name]?.find((item) => item.id === parseInt(params.id))?.data
  );

  const diagnostiqueStore = useSelector(
    (state) => state?.user?.diagnostiqueReducer
  );
  // console.log(diagnostiqueStore)

  const studentDemo = useSelector(getCurrentEleve);

  const formParent = useSelector(getParentForm);

  const [updateParentCredit] = useUpdateParentMutation();

  const { data: datas } = useGetEpreuvexByDiagnostiqueQuery(
    parseInt(params.id)
  );

  const { data: diagnostiqueNiveauxData, isLoading } =
    useGetDiagnostiqueWithNiveauxQuery(parseInt(params.id), {
      refetchOnMountOrArgChange: true,
    });

  // console.log(diagnostiqueNiveauxData);
  const { data: eleve } = useGetEleveQuery(params?.eleveId);

  const [diagnostiqueNiveaux, setDiagnostiqueNiveaux] = useState({});

  const [addDiagnostiqueEleveTentative, { isLoading: addLoading }] =
    useAddDiagnostiqueEleveTentativeMutation();

  const [sendTranscription] = useSendTranscriptionMutation();
  
  const [currentLevel, setCurrentLevel] = useState(
    +searchParams.get("niveau") || 0
  );
  const [current, setCurrent] = useState(+searchParams.get("epreuve") || 0);

  const [selected, setSelected] = useState([]);
  const [selectedTextSpeach, setSelectedTextSpeach] = useState([]);
  const [getWordSelected, setGetWordSelected] = useState([]);
  const [textRecorded, setTextRecorded] = useState("");
  const setTranscription = useState("")[1];
  const [end, setEnd] = useState(false);
  const [opened, setOpened] = useState(false);
  const [isSendingLoading, setIsSendingLoading] = useState(false);
  const [selecteFigure, onSelecteFigure] = useState("");
  const [timer, setTimer] = useState(0);

  const [suggestionManquante, setSuggestionManquante] = useState([]);
  const [suggestionInputActive, setSuggestionInputActive] = useState(null);
  const [savedDiagnosticId, setSavedDiagnosticId] = useState(null);

  // For TSQ Exercice TYpe
  const [setlectChoices, onSelectChoices] = useState([]);

  /**
   *
   */
  useEffect(() => {
    // console.log("lall");
    if (
      diagnostiqueNiveaux?.data &&
      diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.type ===
      "lettreManquante"
    ) {
      // console.log("icicci");
      setSuggestionManquante([
        ...diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.correction_dp
          .map((item, key) =>
            diagnostiqueNiveaux?.data[currentLevel]?.data[
              current
            ]?.choices.find(
              (lettre) => lettre?.toLowerCase() === item?.toLowerCase()
            )
              ? { key, correction: item, choice: "" }
              : null
          )
          .filter((item) => item !== null),
      ]);
    }
  }, [current, currentLevel, diagnostiqueNiveaux?.data]);

  /**
   *
   * @param {*} value
   */
  const onPressKebeard = (value) => {
    if (suggestionInputActive !== null) {
      // console.log({ value, suggestionInputActive });
      setSuggestionManquante([
        ...suggestionManquante.filter(
          (item) => item?.key !== suggestionInputActive
        ),
        {
          ...suggestionManquante.find(
            (item) => item?.key === suggestionInputActive
          ),
          choice: value,
        },
      ]);
      if (
        suggestionManquante[
          suggestionManquante.findIndex(
            (item) => item?.key === suggestionInputActive
          ) + 1
        ]?.key
      ) {
        setSuggestionInputActive(
          suggestionManquante[
            suggestionManquante.findIndex(
              (item) => item?.key === suggestionInputActive
            ) + 1
          ]?.key
        );
      }
    }
  };

  /**
   *
   * @param {*} value
   */
  const handleAddWord = (value) => {
    !selected.includes(value)
      ? setSelected([...selected, value])
      : setSelected(selected.filter((item) => item !== value));
  };

  /**
   *
   * @param {*} value
   */
  const handleRemoveWord = (value) => {
    selected.includes(value) &&
      setSelected(selected.filter((item) => item !== value));
  };

  /**
   * Effacer toutes les lettres sélectionnées
   */
  const handleClearAll = () => {
    setSelected([]);
  };

  const handleAddTextSpeachWord = (value) => {
    // console.log({ value });
    setSelectedTextSpeach((prev) => [
      ...prev.filter((item) => item?.id !== value?.id),
      { ...value },
    ]);
  };

  /**
   *
   */
  const handleNextExercice = async () => {
    // Track if this is the last exercise (Terminer button)
    if (current + 1 === data?.length) {
      Analytics.trackTerminerButton('Lecture Exercise', 'Reading Exercise');
    }

    let note = 0;
    setIsSendingLoading(true);
    const diagnosticType = epreuveCourante?.type;
    try {
      // Add detailed debug logging for each exercise
      const currentExo = epreuveCourante;
      console.log(
        `Exercice index: ${current}, Type: ${diagnosticType}, Titre: ${currentExo?.titre || ''}, Note: ${note}, Bareme: ${currentExo?.bareme}`
      );
      if (diagnosticType === "transcription" || diagnosticType === "dicteeChronometree") {
        const audioResult = await sendElements(getWordSelected, diagnostiqueNiveaux, currentLevel, current, sendTranscription);

        console.log("AudioResult reçu:", audioResult);
        console.log("Score brut:", audioResult?.score);
        console.log("LLM Score:", audioResult?.llm_score);

        // Utiliser le score_binaire si disponible, sinon utiliser le score par défaut
        const scoreToUse = audioResult?.score || audioResult?.llm_score?.score || 0;

        console.log("Score à utiliser:", scoreToUse);
        console.log("Bareme:", diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme);

        if (!audioResult || scoreToUse === 0) {
          console.log("Aucune bonne réponse détectée ou score_binaire = 0");
          setIsSendingLoading(false);
          // return;
        }

        if (diagnosticType === "transcription") {
          // Nouvelle logique pour transcription avec temps_lecture
          const consigneData = diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.consigne?.[0];
          let expectedTime = null;
          let targetWord = null;

          try {
            if (consigneData) {
              const parsedConsigne = JSON.parse(consigneData);
              expectedTime = parsedConsigne.temps_lecture;
              targetWord = parsedConsigne.mot;
            }
          } catch (error) {
            console.error("Erreur parsing consigne:", error);
          }

          console.log("Temps attendu:", expectedTime);
          console.log("Mot cible:", targetWord);
          console.log("Temps réel:", audioResult?.llm_score?.temps_lecture);

          // Utiliser le score_binaire si disponible, sinon utiliser le score par défaut
          const scoreToUse = audioResult?.score || audioResult?.llm_score?.score || 0;
          const actualTime = audioResult?.llm_score?.temps_lecture;

          // Calculer la note basée principalement sur le score de prononciation
          if (scoreToUse === 1) {
            // Mot bien lu = note complète
            note = diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme;
            console.log("Mot bien lu, note complète:", note);

            // Log du temps pour information (sans impact sur la note)
            if (actualTime && expectedTime) {
              const timeDifference = Math.abs(actualTime - expectedTime);
              console.log("Différence de temps:", timeDifference, "secondes");
            }
          } else if (scoreToUse === 0) {
            note = 0;
            console.log("Mot mal lu, aucune note");
          } else {
            // Pour les scores entre 0 et 1, utiliser le calcul proportionnel
            note = calculerNoteFinaleByPercent(
              scoreToUse,
              diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
            );
            console.log("Score proportionnel calculé:", note);
          }
          console.log("Note finale pour transcription:", note);
        } else if (diagnosticType === "dicteeChronometree") {
          // Même logique que transcription : le backend gère déjà la validation du temps
          if (scoreToUse === 1) {
            // Texte bien lu dans le temps imparti = note complète
            note = diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme;
            console.log("Texte bien lu dans le temps, note complète:", note);
          } else if (scoreToUse === 0) {
            note = 0;
            console.log("Texte mal lu ou temps dépassé, aucune note");
          } else {
            // Pour les scores entre 0 et 1, utiliser le calcul proportionnel
            note = calculerNoteFinaleByPercent(
              scoreToUse,
              diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
            );
            console.log("Score proportionnel calculé:", note);
          }
          console.log("Note calculée pour dicteeChronometree:", note);
        } else if (diagnosticType === "wordByWordTranscription") {
          const result = getWordSelected;

          // Calculer la note
          const currentExerciseBareme = diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme;
          let note = 0;

          if (result.performance === 1) {
            note = currentExerciseBareme;
          } else if (result.performance === 0) {
            note = 0;
          } else {
            note = Math.round(result.performance * currentExerciseBareme);
          }

          console.log("Note calculée pour wordByWordTranscription:", note);
        }
      } else if (diagnosticType === "organisation") {
        // Use only one scoring method, not both
        note = compareTextWithPosition(
          selected
            ?.map((item) => item?.split("-")[0])
            .join(" ")
            .toLowerCase(),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].correction_dp
            .join(" ")
            .toLowerCase(),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
        )?.score;
      } else if (diagnosticType === "dictee" || diagnosticType === "dicteeSyllabe") {
        note = compareTextWithPosition(
          selectedTextSpeach
            .map((item) => item.value)
            .join(" ")
            .toLowerCase(),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.correction_dp
            ?.join(" ")
            // split/join au lieu de replaceAll : non supporté sur les vieux
            // WebView Android (< Chrome 85), fréquents sur les itel.
            .split(" -").join("-")
            .split(" - ").join("-")
            .split("- ").join("-")
            .split("-")
            .join(" ")
            .toLowerCase(),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
        )?.score;
      } else if (diagnosticType === "figure") {
        note = correctFigure(
          selecteFigure.join(" "),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.correction_dp.join(" "),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
        );
      } else if (diagnosticType === "wordByWordTranscription") {
        const result = getWordSelected;
        const currentExerciseBareme = diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme;
        if (result && typeof result.performance === 'number') {
          if (result.performance === 1) {
            note = currentExerciseBareme;
          } else if (result.performance === 0) {
            note = 0;
          } else {
            note = Math.round(result.performance * currentExerciseBareme);
          }
          console.log("Note calculée pour wordByWordTranscription:", note);
        } else {
          note = 0;
          console.log("Aucune performance détectée pour wordByWordTranscription, note = 0");
        }
      } else if (diagnosticType === "alphabet") {
        console.log("=== DEBUG alphabet ===");
        console.log("selected:", selected);
        console.log("correction_dp:", diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.correction_dp);
        console.log("bareme:", diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme);

        // Compare selected letters with correction_dp
        note = compareTextWithPosition(
          selected.join(" ").toLowerCase(),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.correction_dp.join(" ").toLowerCase(),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
        )?.score;

        console.log("Note calculée pour alphabet:", note);
        console.log("=== FIN DEBUG alphabet ===");
      } else if (diagnosticType === "tsq") {
        note = correctTsq(
          setlectChoices,
          JSON.parse(
            diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.correction_dp
          ),
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
        );
      } else if (diagnosticType === "lettreManquante") {
        console.log("=== DEBUG lettreManquante ===");
        console.log("suggestionManquante:", suggestionManquante);
        console.log("bareme:", diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme);

        note = correctionLettreManquante(
          suggestionManquante,
          diagnostiqueNiveaux?.data[currentLevel]?.data[current].bareme
        );

        console.log("Note calculée pour lettreManquante:", note);
        console.log("=== FIN DEBUG lettreManquante ===");
      }

      // return console.log({ note });

      // Normaliser la réponse de l'élève selon le type d'exercice
      const studentResponseValue = (
        selected?.length > 0 ? selected.join(" ") :
        selectedTextSpeach?.length > 0 ? selectedTextSpeach.map((i) => i.value).join(" ") :
        suggestionManquante?.length > 0 ? suggestionManquante.join(" ") :
        textRecorded || null
      );

      dispatch(setEscoreNiveau(note));
      dispatch(
        setEpreuveNote({
          epreuveId: diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.id,
          // is_correct: iscorrect,
          note: Math.round(note),
          niveau: diagnostiqueNiveaux?.data[currentLevel]?.niveau,
          response: studentResponseValue,
        })
      );

      trackDiagnosticProgress({
        matiere: "LECTURE",
        eleveId: studentDemo?.id,
        diagnosticId: params?.id,
        niveau: diagnostiqueNiveaux?.data[currentLevel]?.niveau,
        typeExercice: diagnosticType,
        question: current + 1,
        totalQuestions: diagnostiqueNiveaux?.data[currentLevel]?.data?.length,
        note: Math.round(note),
        bareme: diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.bareme,
        derniereQuestionDuNiveau:
          current + 1 === diagnostiqueNiveaux?.data[currentLevel]?.data?.length,
      });

      setTextRecorded("");
      setOpened(false);
      setSelected([]);
      onSelectChoices([]);
      onSelecteFigure([]);
      setSelectedTextSpeach([]);
      setGetWordSelected([]);
      setTranscription("");
      setSuggestionManquante([]);
      setSuggestionInputActive(null);

      const currentEpreuve =
        current + 1 === diagnostiqueNiveaux?.data[currentLevel]?.data?.length
          ? current
          : current + 1;
      navigation(
        `?niveau=${currentLevel}&epreuve=${currentEpreuve}`,
        current + 1 === diagnostiqueNiveaux?.data[currentLevel]?.data?.length
          ? { state: { end: true }, replace: true }
          : { replace: true }
      );

      if (current + 1 === diagnostiqueNiveaux?.data[currentLevel]?.data?.length) {
        setEnd(true);

        // If it's the last level, save immediately in background for instant redirect
        if (diagnostiqueNiveaux?.data?.length === currentLevel + 1) {
          saveDiagnosticInBackground();
        }
      }
    } catch (error) {
      toast.error("Erreur lors de l'envoi. Veuillez réessayer.");
    } finally {
      setIsSendingLoading(false);
    }
  };

  /**
   *
   */
  useEffect(() => {
    if (diagnostiqueNiveauxData) {
      setDiagnostiqueNiveaux({
        ...diagnostiqueNiveaux,
        count: diagnostiqueNiveauxData?.count,
        data: [...diagnostiqueNiveauxData?.data].sort(
          (a, b) => getNumber(a.niveau) - getNumber(b.niveau)
        ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diagnostiqueNiveauxData]);

  /**
   *
   */
  useEffect(() => {
    setCurrentLevel(parseInt(searchParams.get("niveau")));
    setCurrent(parseInt(searchParams.get("epreuve")));
  }, [searchParams]);

  /**
   * Save diagnostic in background for instant redirect
   */
  const saveDiagnosticInBackground = async () => {
    try {
      const { score: scoreNiveau, ...res } = diagnostiqueStore;

      const notes = res?.notes.map((note) => ({
        epreuveId: note?.epreuveId,
        note: note?.note,
        response: note?.response ?? null,
      }));

      const response = await addDiagnostiqueEleveTentative({
        body: {
          ...res,
          notes,
          status: "VALIDE",
          diagnosticId: parseInt(params.id),
        },
        token: csrfToken,
      });

      if (!response?.error && response?.data?.id) {
        setSavedDiagnosticId(response.data.id);

        // Update Redux state
        dispatch(
          setTentatives({
            diagnostique: diagnostiqueStore,
            eleveId: studentDemo?.id,
            diagnosticId: response.data.id,
            type: "LECTURE",
            createdAt: new Date(Date.now()),
          })
        );

        trackDiagnosticCompleted({
          matiere: "LECTURE",
          eleveId: studentDemo?.id,
          diagnosticId: params?.id,
          tentativeId: response.data.id,
          statut: "VALIDE",
          scoreTotal: diagnostiqueStore?.score,
          nombreNiveaux: diagnostiqueNiveaux?.data?.length,
          creditsRestants: formParent?.credits,
        });

        // --- Déduction de crédits (désactivable via ENABLE_CREDIT_SYSTEM) ---
        if (ENABLE_CREDIT_SYSTEM && formParent?.credits > 0) {
          updateParentCredit({
            parentId: formParent?.id,
            credits: formParent?.credits - 25,
          })
            .then((resStatus) => {
              if (resStatus?.data) {
                dispatch(setIncreaseCredit());
                dispatch(
                  setParentForm({
                    ...formParent,
                    credits: resStatus?.data?.data?.credits,
                  })
                );
              }
            })
            .catch((creditError) => {
              console.error("Error updating credits:", creditError);
            });
        }
      }
    } catch (error) {
      console.error("Error saving diagnostic in background:", error);
    }
  };

  /**
   *
   * @returns
   */
  const handleContinueNextLevel = async (forceAnalyse = false) => {
    // If user failed and we must go directly to analysis page
    if (forceAnalyse) {
      try {
        const { score: scoreNiveau, ...res } = diagnostiqueStore;
        const notes = res?.notes.map((note) => ({
          epreuveId: note?.epreuveId,
          note: note?.note,
          response: note?.response ?? null,
        }));

        const response = await addDiagnostiqueEleveTentative({
          body: {
            ...res,
            notes,
            status: "ENCOURS",
            diagnosticId: parseInt(params.id),
          },
          token: csrfToken,
        });

        // --- Déduction de crédits (désactivable via ENABLE_CREDIT_SYSTEM) ---
        if (ENABLE_CREDIT_SYSTEM && formParent?.credits > 0) {
          updateParentCredit({
            parentId: formParent?.id,
            credits: formParent?.credits - 25,
          })
            .then((resStatus) => {
              if (resStatus?.data) {
                dispatch(setIncreaseCredit());
                dispatch(
                  setParentForm({
                    ...formParent,
                    credits: resStatus?.data?.data?.credits,
                  })
                );
              }
            })
            .catch((creditError) => {
              console.error("Error updating credits:", creditError);
            });
        }

        setEnd(true);
        navigation(`../analyse/${response.data.id}?analyseIncomplete=true`, { replace: true });

        if (!response?.error && response?.data?.id) {
          dispatch(
            setTentatives({
              diagnostique: diagnostiqueStore,
              eleveId: studentDemo?.id,
              diagnosticId: response.data.id,
              type: "LECTURE",
              createdAt: new Date(Date.now()),
            })
          );

          trackDiagnosticCompleted({
            matiere: "LECTURE",
            eleveId: studentDemo?.id,
            diagnosticId: params?.id,
            tentativeId: response.data.id,
            statut: "ENCOURS",
            scoreTotal: diagnostiqueStore?.score,
            nombreNiveaux: diagnostiqueNiveaux?.data?.length,
            creditsRestants: formParent?.credits,
          });

          // Navigate directly to analysis page
          setEnd(false);
          await navigation(`../analyse/${response?.data?.id}`, {
            replace: true,
            state: { tentative: response?.data, direct: true },
          });

          return;
        } else {
          toast.error("Erreur lors de la sauvegarde de la tentative.");
        }
      } catch (error) {
        console.error("Error forcing analysis redirect:", error);
        toast.error("Erreur lors de la redirection vers l'analyse.");
        return;
      }
    }

    // Normal flow (success or last level)
    if (diagnostiqueNiveaux?.data?.length === currentLevel + 1) {
      if (savedDiagnosticId) {
        setEnd(false);
        navigation(`../analyse/${savedDiagnosticId}`, { replace: true });
        return;
      }

      try {
        const { score: scoreNiveau, ...res } = diagnostiqueStore;
        const notes = res?.notes.map((note) => ({
          epreuveId: note?.epreuveId,
          note: note?.note,
          response: note?.response ?? null,
        }));

        const response = await addDiagnostiqueEleveTentative({
          body: {
            ...res,
            notes,
            status: "VALIDE",
            diagnosticId: parseInt(params.id),
          },
          token: csrfToken,
        });

        if (response?.error) {
          toast.error("Erreur lors de l'enregistrement. Veuillez réessayer.");
          return;
        }

        dispatch(
          setTentatives({
            diagnostique: diagnostiqueStore,
            eleveId: studentDemo?.id,
            diagnosticId: response?.data?.id,
            type: "LECTURE",
            createdAt: new Date(Date.now()),
          })
        );

        trackDiagnosticCompleted({
          matiere: "LECTURE",
          eleveId: studentDemo?.id,
          diagnosticId: params?.id,
          tentativeId: response?.data?.id,
          statut: "VALIDE",
          scoreTotal: diagnostiqueStore?.score,
          nombreNiveaux: diagnostiqueNiveaux?.data?.length,
          creditsRestants: formParent?.credits,
        });

        // --- Déduction de crédits (désactivable via ENABLE_CREDIT_SYSTEM) ---
        if (ENABLE_CREDIT_SYSTEM && formParent?.credits > 0) {
          updateParentCredit({
            parentId: formParent?.id,
            credits: formParent?.credits - 25,
          })
            .then((resStatus) => {
              if (resStatus?.data) {
                dispatch(setIncreaseCredit());
                dispatch(
                  setParentForm({
                    ...formParent,
                    credits: resStatus?.data?.data?.credits,
                  })
                );
              }
            })
            .catch((creditError) => {
              console.error("Error updating credits:", creditError);
            });
        }

        setEnd(false);
        navigation(`../analyse/${response?.data?.id}`, { replace: true });
      } catch (error) {
        console.error("Error in handleContinueNextLevel:", error);
        toast.error("Une erreur est survenue. Veuillez réessayer.");
      }
    } else {
      // Continue to next level normally
      trackDiagnosticNiveauSuivant({
        matiere: "LECTURE",
        eleveId: studentDemo?.id,
        diagnosticId: params?.id,
        niveauSuivant: diagnostiqueNiveaux?.data[currentLevel + 1]?.niveau,
      });
      setEnd(false);
      navigation(`?niveau=${currentLevel + 1}&epreuve=${0}`, {
        replace: true,
      });
    }
  };


  /**
   *
   */
  const handleQuit = async () => {
    try {
      await addDiagnostiqueEleveTentative({
        body: { ...diagnostiqueStore },
        token: csrfToken,
      });
      // console.log({ res });
      navigation("/" + params?.eleveId + "/matiere", {
        replace: true,
      });
    } catch (error) {
      alert("Une erreur c'est produite, reessayer plutard");
      // console.log({ error });
    }
  };

  // console.log("@@@@@@@@@@@@@@@@@@@@@@@");
  // console.log({
  //   currentLevel,
  //   current,
  //   data,
  // });
  // console.log({ diagnostiqueNiveaux });

  // Ajouté juste après la déclaration des hooks d'état principaux
  useEffect(() => {
    const diagnosticType = diagnostiqueNiveaux?.data?.[currentLevel]?.data?.[current]?.type;
    if (
      diagnosticType === "wordByWordTranscription" &&
      getWordSelected &&
      getWordSelected.performance !== undefined
    ) {
      handleNextExercice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getWordSelected]);

  console.log(diagnostiqueStore?.notes)
  console.log(currentLevel)
  console.log(diagnostiqueNiveaux)

  // Accès sécurisés pour le rendu : un niveau/épreuve manquant ou une
  // correction_dp absente ou non-JSON ne doit plus faire planter la page.
  const niveauCourant = diagnostiqueNiveaux?.data?.[currentLevel];
  const epreuveCourante = niveauCourant?.data?.[current];
  const correctionDp = epreuveCourante?.correction_dp;
  const tsqChoicesCount = (() => {
    try {
      return JSON.parse(correctionDp?.[0])?.length ?? 0;
    } catch {
      return 0;
    }
  })();

  return isLoading ? (
    <div className="h-[100dvh] w-full flex flex-col justify-center items-center">
      <Loader />
      <p>Chargement des exercices...</p>
    </div>
  ) : diagnostiqueNiveauxData?.count === 0 ? (
    <div className="h-[100dvh] w-full flex justify-center items-center flex-col gap-4">
      <p>Aucune question pour le moment</p>
      <Button radius={"md"} onClick={() => navigation(-1)}>
        retour
      </Button>
    </div>
  ) : (
    <Template
      footerStyle={{ height: 70 }}
      footer={
        isLoading || end ? null : diagnostiqueNiveaux?.data &&
          (textRecorded ||
            selecteFigure?.length > 0 ||
            selected?.length === correctionDp?.length ||
            (epreuveCourante?.type === "tsq" &&
              setlectChoices?.length === tsqChoicesCount) ||
            getWordSelected.length ===
            spliterSentences(correctionDp?.join(" "))?.length ||
            selectedTextSpeach?.length ===
            spliterText(correctionDp?.join(" "))?.length ||
            correctionLettreManquanteLength(suggestionManquante)) ? (
          <div
            style={{
              display: "flex",
              gap: 10,
              padding: "0 10px",
              marginTop: 5,
            }}
          >
            {diagnostiqueNiveaux?.acount === 0 ? (
              <Button
                onClick={() => navigation(-1, { replace: true })}
                style={{ width: "100%", height: 40, marginTop: 10 }}
                radius={"md"}
              >
                Retour
              </Button>
            ) : !end &&
              diagnostiqueNiveaux?.data &&
              (textRecorded ||
                selecteFigure?.length > 0 ||
                selected?.length > 0 ||
                (epreuveCourante?.type === "tsq" &&
                  setlectChoices.length === tsqChoicesCount) ||
                getWordSelected?.length ===
                spliterSentences(correctionDp?.join(" "))?.length ||
                selectedTextSpeach?.length ===
                spliterText(correctionDp?.join(" "))?.length ||
                correctionLettreManquanteLength(suggestionManquante) ||
                (epreuveCourante?.type === "alphabet" &&
                  selected?.length > 0) ||
                (epreuveCourante?.type === "wordByWordTranscription" &&
                  getWordSelected && getWordSelected.performance !== undefined)) ? (
              <Button
                onClick={() => {
                  // Track the Valider button click
                  Analytics.trackValiderButton('Lecture Exercise', 'Reading');
                  handleNextExercice();
                }}
                style={{ width: "100%", height: 40, marginTop: 10 }}
                radius={"md"}
                disabled={
                  textRecorded ||
                    selecteFigure ||
                    selected?.length > 0 ||
                    (epreuveCourante?.type === "tsq" &&
                      setlectChoices?.length === tsqChoicesCount) ||
                    getWordSelected?.length ===
                    spliterSentences(correctionDp?.join(" "))?.length ||
                    selectedTextSpeach?.length ===
                    spliterText(correctionDp?.join(" "))?.length ||
                    correctionLettreManquanteLength(suggestionManquante) ||
                    (epreuveCourante?.type === "alphabet" &&
                      selected?.length > 0) ||
                    (epreuveCourante?.type === "wordByWordTranscription" &&
                      getWordSelected && getWordSelected.performance !== undefined)
                    ? false
                    : true
                }
                loading={isSendingLoading}
              >
                Valider
              </Button>
            ) : null}
          </div>
        ) : null
      }
    // style={{ userSelect: "none" }}
    >
      {/* Word quizz */}
      {datas && datas?.count === 0 ? (
        "Pas d'exercice"
      ) : end ? (
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {isLoading || !diagnostiqueNiveaux?.data ? (
            <Loader />
          ) : (
            <Finish
              data={niveauCourant}
              globalNote={niveauCourant?.data?.reduce(
                (acc, cur) => acc + cur?.bareme,
                0
              )}
              score={diagnostiqueStore?.notes
                ?.filter(
                  (note) =>
                    note?.niveau ===
                    niveauCourant?.niveau
                )
                ?.reduce((acc, curr) => acc + curr?.note, 0)}
              // note={niveauCourant?.data?.length}
              note={diagnostiqueStore?.notes
                ?.filter(
                  (note) =>
                    String(note?.niveau) ===
                    String(niveauCourant?.niveau)
                )
                ?.reduce((acc, curr) => acc + (curr?.note || 0), 0)}
              onRestart={() => window.location.reload()}
              seuil={
                niveauCourant?.data?.reduce(
                  (acc, cur) => acc + (cur?.bareme || 0),
                  0
                )
              }
              onQuit={handleQuit}
              onCountinue={handleContinueNextLevel}
              loading={addLoading}
              finish={
                diagnostiqueNiveaux?.data?.length === currentLevel + 1
              }
            />
          )}
        </div>
      ) : (
        diagnostiqueNiveaux &&
        diagnostiqueNiveaux?.data && (
          <>
            <WordPage
              data={diagnostiqueNiveaux && diagnostiqueNiveaux?.data ? diagnostiqueNiveaux?.data : []}
              current={current}
              currentLevel={currentLevel}
              selected={selected}
              onTranscription={setTranscription}
              handleAddWord={handleAddWord}
              handleRemoveWord={handleRemoveWord}
              handleClearAll={handleClearAll}
              resetTranscription={current}
              randomeImage={progressImage[currentLevel]}
              eleve={eleve}
              studentDemo={studentDemo}
              handleGoBack={() => navigation(-1)}
              onTextChange={setTextRecorded}
              textRecorded={textRecorded}
              handleAddTextSpeachWord={handleAddTextSpeachWord}
              selectedTextSpeach={selectedTextSpeach}
              onGetWordSelected={setGetWordSelected}
              getTimer={setTimer}
              onCheckInput={setSuggestionInputActive}
              suggestionManquante={suggestionManquante}
              suggestionInputActive={suggestionInputActive}
              onPressKebeard={onPressKebeard}
              onSelecteFigure={onSelecteFigure}
              onSelectChoice={onSelectChoices}
              handleNextExercice={handleNextExercice}
            />
          </>
        )
      )}
      {opened ? (
        <div
          className=""
          style={{
            width: "100%",
            height: "100dvh",
            backgroundColor: "rgba(0,0,0,0.1)",
            position: "fixed",
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <div
            className=""
            style={{
              backgroundColor: "#ffff",
              width: "100%",
              height: 200,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: 10,
            }}
          >
            <MoodEmpty strokeWidth={1} size={58} color={"black"} />
            <span
              style={{
                marginTop: 10,
                color:
                  selected.join(" ").toLowerCase() !== data?.[current]?.correction_dp?.join(" ").toLowerCase()
                    ? "red"
                    : "green",
              }}
            >
              {selected.join(" ").toLowerCase() !== data?.[current]?.correction_dp?.join(" ").toLowerCase()
                ? "Oups, Vous n'avez pas trouvé"
                : "Bravo! vous avez trouvé"}
            </span>
            <Button
              style={{ width: "100%", marginTop: 40 }}
              radius={"sm"}
              onClick={handleNextExercice}
            >
              {current + 1 === data?.length ? "Terminer" : "Suivant"}
            </Button>
          </div>
        </div>
      ) : null}
    </Template>
  );
}

export default ExerciceLecturePage;